import Marquee from "react-fast-marquee";
import { Star, Quote } from "lucide-react";
import { Reveal, Kicker } from "@/components/Reveal";

const TESTIMONIALS = [
  { name: "Ananya & Rohan Mehta", trip: "Maldives Overwater Romance", text: "The seaplane arrival, the sandbank dinner — every detail felt composed just for us. Best honeymoon decision we made." },
  { name: "Vikram Sethi", trip: "Dubai Dazzler with Abu Dhabi", text: "Flights, desert safari, Burj tickets — all handled. I just showed up. The 24×7 support is real, they answered at 2am." },
  { name: "The Kapoor Family", trip: "Bali Family Adventure", text: "Travelling with two kids is usually chaos. T&T made it feel effortless — the driver even had car seats ready." },
  { name: "Ishita Raghavan", trip: "Japan Essentials: Tokyo & Kyoto", text: "The JR Pass, the bullet train seats, the kaiseki dinner — planned to the minute without ever feeling rushed." },
  { name: "Arjun & Sara Nair", trip: "Greece & Santorini Dreamscape", text: "That caldera sunset cruise was worth every rupee. Transparent pricing, no surprises, gorgeous stays." },
  { name: "Meera & Dev Patel", trip: "European Grandeur", text: "Nine days, three countries, zero stress. Visas, trains, hotels — one booking and everything simply worked." },
];

function Card({ t }) {
  return (
    <figure className="w-80 sm:w-96 mx-4 rounded-2xl border border-white/10 bg-onyx-800 p-7 hover:border-gold/40 transition-colors" data-testid={`testimonial-${t.name.split(" ")[0].toLowerCase()}`}>
      <Quote size={20} className="text-gold/60" />
      <blockquote className="mt-4 text-sm text-slate-300 leading-relaxed font-serif italic">“{t.text}”</blockquote>
      <figcaption className="mt-5 pt-4 border-t border-white/10">
        <div className="flex gap-0.5 mb-2">
          {[...Array(5)].map((_, i) => <Star key={i} size={12} className="fill-gold text-gold" />)}
        </div>
        <div className="text-sm font-semibold text-slate-100">{t.name}</div>
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold mt-1">{t.trip}</div>
      </figcaption>
    </figure>
  );
}

export default function Testimonials() {
  return (
    <section className="py-24 sm:py-32 overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Kicker>Traveller Stories</Kicker>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl text-slate-50 tracking-tight max-w-2xl">
            40,000 journeys, <em className="gold-text not-italic">told by them</em>
          </h2>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="mt-14">
        <Marquee speed={35} gradient gradientColor="#0B0F17" gradientWidth={120} pauseOnHover>
          {TESTIMONIALS.map((t) => <Card key={t.name} t={t} />)}
        </Marquee>
      </Reveal>
    </section>
  );
}
